import './OkulyonetimProductListBase.scss'

import { Col, Pagination, Row } from 'antd'
import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import AppContext from '../../../context/AppContext'
import {OkulYonetimUrunFiltre, useOkulyonetimrunlerQuery} from '../../../gql/GeneratedGraphqlTypes'
import { DEFAULT_API_TOKEN } from '../../../utils/const'
import Spinner from '../../spinner/Spinner'
import OkulyonetimAlert from '../okulyonetim-alert/OkulyonetimAlert'
import OkulyonetimProduct from '../okulyonetim-product/OkulyonetimProduct'

const OkulyonetimProductListBase = () => {
  const { slug } = useContext(AppContext)
  const navigate = useNavigate()
  const { token } = useContext(AppContext)
  const [currentPage, setCurrentPage] = useState(1) // for pagination

  let queryVariables = {
    slug: slug!,
    filtre: {} as OkulYonetimUrunFiltre,
  }
  queryVariables.filtre = {
    sayfa: currentPage - 1,
  }
  const {
    data,
    loading: okulYonetimUrunLoading,
    error,
  } = useOkulyonetimrunlerQuery({
    variables: queryVariables,
    skip: token === '' || token === DEFAULT_API_TOKEN,
  })

  if (okulYonetimUrunLoading) {
    return <Spinner showSpinner={okulYonetimUrunLoading} color={'red'}></Spinner>
  }

  if (error) {
    console.log(error)
    navigate(`/`)
  }
  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  return (
    <div className="okulyonetim-product-list okul-yonetim-base">
      <Row gutter={[24, 24]}>
        <Col xs={24} lg={24}>
          <OkulyonetimAlert />
          <Row className="okulyonetim-product-list-row" gutter={[24, 24]} wrap={true}>
            {data?.okul?.okulyonetimUrunler?.okulyonetim_urunler?.map((product, index) => (
              <Col xs={24} sm={12} md={8} lg={6} key={index}>
                <OkulyonetimProduct
                  image={product?.urun?.resim_url ? product.urun.resim_url : product?.urun?.resim!}
                  title={product?.urun?.isim!}
                  pdf_url={product?.urun?.pdf_url}
                  pdf={product?.urun?.pdf}
                  id={product?.urun?.id ? product.urun.id : 1}
                  price={product?.urun?.etiket_fiyati!}
                  mufredat={product?.urun?.mufredat ? product.urun.mufredat : false}
                  oneri={product?.urun?.oneri ? product.urun.oneri : false}
                  quantity={1}
                  initialIsFavori={product?.urun?.is_favori ? product.urun.is_favori : false}
                />
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
      <Pagination
        current={currentPage}
        pageSize={20}
        total={data?.okul?.okulyonetimUrunler?.toplam_urun_sayisi!}
        onChange={handlePageChange}
        style={{ marginTop: 16, textAlign: 'center' }}
        showSizeChanger={false}
      />
    </div>
  )
}

export default OkulyonetimProductListBase
